/**
 * Sincroniza la nota de carrito recuperada (cartNoteRecovered) con textareas del drawer/página.
 */
(function (global) {
  'use strict';

  function stripNote(note) {
    if (
      global.B2BSessionStorage &&
      typeof global.B2BSessionStorage.stripEncodedNoteSegments === 'function'
    ) {
      return global.B2BSessionStorage.stripEncodedNoteSegments(note || '');
    }
    if (note == null || note === '') return '';
    return String(note).replace(/,SHIPPING_PRICE.*/, '');
  }

  function syncCartNoteTextarea(textareaId) {
    var el = global.document.getElementById(textareaId);
    if (!el) return;

    var recovered;
    try {
      recovered = global.sessionStorage.getItem('cartNoteRecovered');
    } catch (e) {
      return;
    }
    if (!recovered) return;

    var note = stripNote(recovered);
    if (!note || el.value === note) return;

    el.value = note;
  }

  global.B2BCartNote = {
    stripNote: stripNote,
    syncCartNoteTextarea: syncCartNoteTextarea,
  };
})(typeof window !== 'undefined' ? window : this);
